// extracted by mini-css-extract-plugin
export var small = "index-module--small--3uUo-";
export var large = "index-module--large--10RGo";